// extracted by mini-css-extract-plugin
export var option = "_5q-0";
export var optionCard = "_5q-f";
export var optionContent = "_5q-g";
export var optionIcon = "_5q-i";
export var optionIconBox = "_5q-h";
export var optionLabel = "_5q-j";
export var optionPill = "_5q-m";
export var optionPillBadge = "_5q-p";
export var optionPillIcon = "_5q-n";
export var optionPillLabel = "_5q-o";
export var optionRadio = "_5q-k";
export var optionRadioInner = "_5q-l";
export var optionReveal = "_5q-2";
export var optionRevealDelay0 = "_5q-3";
export var optionRevealDelay1 = "_5q-4";
export var optionRevealDelay10 = "_5q-d";
export var optionRevealDelay11 = "_5q-e";
export var optionRevealDelay2 = "_5q-5";
export var optionRevealDelay3 = "_5q-6";
export var optionRevealDelay4 = "_5q-7";
export var optionRevealDelay5 = "_5q-8";
export var optionRevealDelay6 = "_5q-9";
export var optionRevealDelay7 = "_5q-a";
export var optionRevealDelay8 = "_5q-b";
export var optionRevealDelay9 = "_5q-c";
export var optionSelected = "_5q-1";